<template lang="pug">
include /mixins
modal-wrapper(
  :info='{}'
  @close='$emit("close")'
)
  +b.ds-panel--space_xl
    +e.element--offset_vertical
      +b.ds-caption--size_lg.--medium.--appearance_center.P {{ info.campaign.campaign_title }}
    +e.element--offset_vertical
      +b.g-row--space_xl-mac.--appearance_spaced
        +b.g-cell.g-cols--6.--6-xl(
          v-for='variant in info.set'
        )
          sales-cart-variant-card(
            :variant='variant'
            :key='variant.id'
            @updateCart='updateCart($event, variant)'
          )
    +b.line-h--light
    +e.element--offset_vertical
      table
        template(v-if='info.campaign.discount_summ_amount')
          tr
            td
              +b.tt-space_pb--2.ds-caption--size_sm.--medium.--appearance_right-md.P {{ _('Стоимость товаров по отдельности:') }}
            td
              +b.tt-space_pb--2.ds-caption--size_sm.--bold.--appearance_right.P(
                v-html='getSplittedHtml(info.campaign.price_without_campaign)'
              )
          tr
            td
              +b.tt-space_pb--2.ds-caption--size_sm.--medium.--appearance_right-md.P {{ _('Скидка на комплект:') }}
            td
              +b.tt-space_pb--2.ds-caption--size_sm.--bold.--appearance_right.--color_red.P() {{ info.campaign.complect_discount_percent  }}%
          tr
            td
              +b.ds-caption--size_sm.--bold.--appearance_right-md.P {{ _('Вы заплатите:') }}
            td
              +b.ds-caption--size_sm.--bold.--appearance_right.P(
                v-html='getSplittedHtml(info.campaign.price_with_discount)'
              )
        template(v-if='info.campaign.price_without_campaign && !info.campaign.discount_summ_amount')
          tr
            td
              +b.ds-caption--size_sm.--bold.--appearance_right-md.P {{ _('Стоимость комплекта:') }}
            td
              +b.ds-caption--size_sm.--bold.--appearance_right.P(
                v-html='getSplittedHtml(info.campaign.price_without_campaign)'
              )
    template(v-if='info.campaign.discount_summ_amount')
      +b.line-h--light
      +e.element--offset_vertical
        table
          tr
            td
              +b.ds-caption--size_sm.--medium.P {{ _('Купив этот комплект, вы экономите:') }}
            td
              +b.ds-caption--size_sm.--bold.--appearance_right.P(
                v-html='getSplittedHtml(info.campaign.discount_summ_amount)'
              )
    +b.line-h--light
    +e.element--offset_vertical
      row(align='center' justify='center')
        cell(cols='12 6-md 5-xl')
          +b.tt-button--mini.BUTTON(
            @click.prevent='$emit("close")'
          )
            +e.title.SPAN {{ _('Назад в корзину') }}
</template>

<script>

export default {
  name: 'SetView',
  props: ['info'],
  data() {
    return {
      currency: window.currency,
    }
  },
}
</script>
